export default class OfferDocumentation {

  id = null;
  documentType = 'OFFER_TASK';
  fileType = null;
  size = '';
  fileName = '';
  md5 = '';
  startDate = null;
  endDate = null;
  signed = false;
  toBeSigned = false;
  assignedTo = null;
  customer = null;
  task = null;
  price = 0.0;
  appointmentDate = null;
  factuallyCorrect = false;
  technicallyCorrect = false;
  advised = false;
  containAB = false;
  orderIdFromUser = '';
  description = '';
  supplier = '';
  supplierId = null;

  constructor() {
  }
}